'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CancellationTokenSource = function () {
	_createClass(CancellationTokenSource, null, [{
		key: 'createLinkedTokenSource',
		value: function createLinkedTokenSource() {
			for (var _len = arguments.length, linkedTokens = Array(_len), _key = 0; _key < _len; _key++) {
				linkedTokens[_key] = arguments[_key];
			}

			return new CancellationTokenSource({ linkedTokens: linkedTokens });
		}
	}]);

	function CancellationTokenSource() {
		var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
		    _ref$linkedTokens = _ref.linkedTokens,
		    linkedTokens = _ref$linkedTokens === undefined ? [] : _ref$linkedTokens;

		_classCallCheck(this, CancellationTokenSource);

		var _createCancellationTo = createCancellationToken(),
		    token = _createCancellationTo.token,
		    cancel = _createCancellationTo.cancel,
		    isCanceled = _createCancellationTo.isCanceled,
		    destroy = _createCancellationTo.destroy,
		    throwIfDestroyed = _createCancellationTo.throwIfDestroyed;

		var linkedRegistrations = [];
		var doDestroy = function doDestroy() {
			linkedRegistrations.forEach(function (unregister) {
				return unregister();
			});
			linkedRegistrations.length = 0;
			destroy();
		};
		var doCancel = function doCancel() {
			linkedRegistrations.forEach(function (unregister) {
				return unregister();
			});
			cancel();
		};

		for (var i = 0; i < linkedTokens.length; i++) {
			var linkedToken = linkedTokens[i];

			if (linkedToken.isCancellationRequested) {
				doCancel();
				break;
			}

			linkedRegistrations.push(linkedToken.register(doCancel));
		}

		Object.defineProperties(this, {
			token: {
				get: function get() {
					throwIfDestroyed();
					return token;
				}
			},
			cancel: {
				value: doCancel
			},
			isCancellationRequested: {
				get: function get() {
					return isCanceled();
				}
			},
			destroy: {
				value: doDestroy
			}
		});
	}

	return CancellationTokenSource;
}();

exports.default = CancellationTokenSource;


function createCancellationToken() {
	var _isCanceled = false;
	var isDestroyed = false;
	var registrations = [];
	var throwIfDestroyed = function throwIfDestroyed() {
		if (isDestroyed) {
			throw new Error('token has already been destroyed');
		}
	};

	return {
		cancel: function cancel() {
			throwIfDestroyed();
			if (_isCanceled) {
				return;
			}

			_isCanceled = true;
			registrations.slice().forEach(function (onCanceled) {
				return onCanceled();
			});
			registrations = [];
		},
		destroy: function destroy() {
			if (isDestroyed) {
				return;
			}

			isDestroyed = true;
			registrations = [];
		},
		isCanceled: function isCanceled() {
			return _isCanceled;
		},

		throwIfDestroyed: throwIfDestroyed,
		token: {
			get isCancellationRequested() {
				return _isCanceled;
			},
			register: function register(callback) {
				if (typeof callback !== 'function') {
					throw new Error('invalid callback');
				}

				throwIfDestroyed();

				if (_isCanceled) {
					callback();
					return function () {};
				}

				registrations.push(callback);
				return function () {
					var index = registrations.indexOf(callback);
					if (index !== -1) {
						registrations.splice(index, 1);
					}
				};
			}
		}
	};
}